import { useState, useRef, useEffect, useCallback } from 'react';
import { useApp } from '@pixi/react';

export const useOutSideClick = () => {
  const ref = useRef();
  const { stage } = useApp();
  const [state, setState] = useState({
    hasClickedOutside: false,
  });

  const contains = (point, container) => {
    const localPoint = container.toLocal(point);
    return (
      localPoint.x >= 0 &&
      localPoint.x <= container.width &&
      localPoint.y >= 0 &&
      localPoint.y <= container.height
    );
  };

  const handleEvent = useCallback(
    (e) => {
      const point = e.data.global;
      setState({ hasClickedOutside: false });
      if (ref && ref.current) {
        setState({ hasClickedOutside: !contains(point, ref.current) });
      }
    },
    [setState]
  );

  useEffect(() => {
    stage.interactive = true;
    stage.addEventListener('pointerdown', handleEvent);
    return () => {
      stage.interactive = false;
      stage.removeEventListener('pointerdown', handleEvent);
    };
  }, [handleEvent, stage]);

  return [ref, state.hasClickedOutside, setState];
};
